<!-- ALL DATA COPY PASTED EXCEPT UIENGINE *ngIf="data && chartDataSets" -->

@if (data) {
  <div style="display: block;background-color: white;overflow-y: auto;">
    <div class="row m-1">
      <div [class]="!hideLabels?'dashboard-card-top-section':'dashboard-card-top-section'">
        <div class="btn btn-group px-0">
          @if (data.type=='line' || data.type=='bar') {
            <select class="btn bg-white border btn-sm"
              [(ngModel)]="chartType">
              <option class="dropdown-item" value="line">Line</option>
              <option class="dropdown-item" value="bar">Bar</option>
            </select>
          }
          <select class="btn bg-white border btn-sm"
            [(ngModel)]="filterType" (change)="getData()">
            <option class="dropdown-item" value="fixed">Fixed</option>
            <option class="dropdown-item" value="custom">Custom</option>
          </select>
          @if (timePeriodList && data.time_period && filterType=='fixed') {
            <select class="btn bg-white border btn-sm"
              [(ngModel)]="data.time_period" (change)="setFilter($event)">
              @for (entry of timePeriodList; track entry) {
                @if (entry.code!='custom') {
                  <option class="dropdown-item" [value]="entry.code">
                  {{entry.display}}</option>
                }
              }
            </select>
          }
          @if (filterType=='custom') {
            <input type="text" ngxDaterangepickerMd
              class="btn bg-white border datepicker-search" placeholder="Choose date" showCancel="true"
              [singleDatePicker]="false" [autoApply]="false"
              [timePicker]="false"
              [timePickerIncrement]="1" [startKey]="'FROM'"
              [endKey]="'TO'"
              (change)="valueChange($event)" autocomplete="off" />
          }
        </div>
        @if (!hideLabels) {
          <h4 class="flex-grow-1"><b>{{data.widget_name}}</b></h4>
        }
      </div>
    </div>
    @if (config.objData) {
      <app-pop-uiengine [action]="config"></app-pop-uiengine>
    }
  </div>
}


<!--
-->